import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiRequestService, LogService, UseCase } from '@prekog/common-ui';
import { Observable } from 'rxjs';

import { STORE_BACKEND_URL } from 'src/app/app.config';
import { PartnerStatisticTotals } from '../../shared/models/partner-statistic-totals.model';
import { GetPartnerStatisticTotalsRequest } from './get-partner-statistic-totals.request';

@Injectable({
    providedIn: 'root'
})
export class LoadPartnerGlobalTotalsUseCase extends UseCase<GetPartnerStatisticTotalsRequest, Observable<PartnerStatisticTotals>> {
    private _apiRequestService = inject(ApiRequestService);
    private _storeBaseUrl = inject<string>(STORE_BACKEND_URL);

    constructor(_logService: LogService, _http: HttpClient) {
        super(_logService, _http);
    }

    protected override executeBusinessLogic(request: GetPartnerStatisticTotalsRequest | void): Observable<PartnerStatisticTotals> | void {
        return this._apiRequestService.sendRequest<GetPartnerStatisticTotalsRequest, PartnerStatisticTotals>(
            this._storeBaseUrl,
            request as GetPartnerStatisticTotalsRequest,
            true,
            '/admin/getTotalPartnerStatistics'
        );
    }
}
